import { Link } from "react-router-dom";

export default function ShippingPolicy() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="max-w-3xl w-full bg-white dark:bg-gray-800 p-8 md:p-12 rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold text-center mb-6">Shipping Policy</h1>
        <p className="text-lg text-center mb-6">
          At <span className="font-semibold">PrintKaro.shop</span>,{" "}
          <span className="text text-red-700 font-bold">we do not offer any shipping services</span>. Customers are required to collect
          their printed documents directly from our stationary store.
        </p>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-2">1. No Shipping Services</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              • We <strong>do not provide shipping</strong> for any printed documents.
              <br />• All orders must be collected in person from our stationary store.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">2. Collection Process</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              • Once your order is ready, you will receive a notification via push notification on
              update in order history.
              <br />• Please bring your <strong>order confirmation number</strong>
              <br />• Orders will be held for <strong>7 days</strong> from the ready date. After
              this period, uncollected orders may be discarded.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">3. Store Location and Timings</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              • Store timings are <strong>8:00 AM to 4:00 PM</strong>, Monday to Saturday.
              <br />• We are closed on Sundays and public holidays.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">4. Contact for Support</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              If you have any questions about your order or need assistance, email us at{" "}
              <span className="font-semibold text-blue-600 dark:text-blue-400">
                printkaro369@gmail.com
              </span>{" "}
              or call{" "}
              <span className="font-semibold text-blue-600 dark:text-blue-400">
                +91 95606 34482
              </span>
              .
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
